import { CatalogInfo } from './CatalogInfo';
import { ProductInfo } from './ProductInfo';

export class GroupInfo extends CatalogInfo {
    ProductInfoList: ProductInfo[];
}
